import { CSS, StyleProps } from "@shared/primitive-components"

export const contentWrap = () => ({
  margin: `1em 0`,
})

export const marginBottom = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(4),
})

export const makeColumnStyle = (needsBorder?: boolean) => (): CSS => ({
  width: `50%`,
  flexDirection: `column`,
  padding: needsBorder ? `10px 100px 25px 25px` : `10px 100px 25px 0`,
  borderLeft: needsBorder ? `1px solid #7f7f7f` : undefined,
})

export const labelText = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(2),
})

export const labelInstruction = (props: StyleProps) => ({
  marginBottom: props.theme.pxToEm(15),
})

export const dateField = () => ({
  maxWidth: `220px`,
})

export const error = (props: StyleProps) => ({
  display: `block`,
  color: props.theme.palette.error,
  marginTop: props.theme.spacing(2),
})

export const checkboxContainer = (): CSS => ({
  flexDirection: `column`,
  alignItems: `right`,
  width: `100%`,
})
